class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  getSkeletonHTML() {
    return `
      <div class="cart-recs-header">
        <div class="title">${this.querySelector('.title')?.textContent || 'You May Also Like'}</div>
        <div class="cart-recs-arrows">
          <button type="button" class="cart-recs-arrow cart-recs-arrow--prev" aria-label="Previous" disabled>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>
          <button type="button" class="cart-recs-arrow cart-recs-arrow--next" aria-label="Next" disabled>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>
          </button>
        </div>
      </div>
      <div class="cart-recs-skeleton">
        <div class="cart-recs-skeleton__slide">
          <div class="cart-recs-skeleton__image"></div>
          <div class="cart-recs-skeleton__text">
            <div class="cart-recs-skeleton__line"></div>
            <div class="cart-recs-skeleton__line cart-recs-skeleton__line--short"></div>
          </div>
          <div class="cart-recs-skeleton__btn"></div>
        </div>
        <div class="cart-recs-skeleton__slide">
          <div class="cart-recs-skeleton__image"></div>
          <div class="cart-recs-skeleton__text">
            <div class="cart-recs-skeleton__line"></div>
            <div class="cart-recs-skeleton__line cart-recs-skeleton__line--short"></div>
          </div>
          <div class="cart-recs-skeleton__btn"></div>
        </div>
      </div>
    `;
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    const hasContent = this.querySelector('.cart-recs-slider')?.children.length > 0;
    if (!hasContent) {
      this.innerHTML = this.getSkeletonHTML();
    }

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        if (html === null) return;
        
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        this.initSliderArrows();
      })
      .catch(e => {
        console.error(e);
      });
  }

  initSliderArrows() {
    const slider = this.querySelector('.cart-recs-slider');
    const prevBtn = this.querySelector('.cart-recs-arrow--prev');
    const nextBtn = this.querySelector('.cart-recs-arrow--next');

    if (!slider || !prevBtn || !nextBtn) return;

    const getSlideWidth = () => {
      const slide = slider.querySelector('.cart-recs-slide');
      if (!slide) return 0;
      return slide.offsetWidth + parseFloat(getComputedStyle(slider).gap);
    };

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
    });

    const updateArrowStates = () => {
      if (slider.clientWidth === 0) return;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      prevBtn.disabled = slider.scrollLeft <= 1;
      nextBtn.disabled = maxScroll <= 1 || slider.scrollLeft >= maxScroll - 1;
    };

    slider.addEventListener('scroll', updateArrowStates, { passive: true });

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        updateArrowStates();
      }
    });
    observer.observe(slider);
  }
}
customElements.define('cart-recommendations', CartRecommendations);

document.addEventListener('click', (e) => {
  const arrow = e.target.closest('.cart-recommendations--empty .cart-recs-arrow');
  if (!arrow) return;
  const container = arrow.closest('.cart-recommendations--empty');
  const slider = container?.querySelector('.cart-recs-slider');
  if (!slider) return;

  const slide = slider.querySelector('.cart-recs-slide');
  if (!slide) return;
  const slideWidth = slide.offsetWidth + parseFloat(getComputedStyle(slider).gap);

  if (arrow.classList.contains('cart-recs-arrow--prev')) {
    slider.scrollBy({ left: -slideWidth, behavior: 'smooth' });
  } else {
    slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
  }
});
